var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7317 24.7948C17.0326 25.0795 17.5073 25.0662 17.792 24.7653C18.0766 24.4644 18.0634 23.9897 17.7624 23.7051L12.5234 18.75H25.2471C25.6613 18.75 25.9971 18.4142 25.9971 18C25.9971 17.5857 25.6613 17.25 25.2471 17.25H12.5211L17.7624 12.2927C18.0634 12.0081 18.0766 11.5334 17.792 11.2324C17.5073 10.9315 17.0326 10.9183 16.7317 11.2029L10.3145 17.2724C10.1482 17.4296 10.0482 17.6298 10.0145 17.8385C10.0031 17.8905 9.99707 17.9445 9.99707 18C9.99707 18.0575 10.0036 18.1136 10.0159 18.1675C10.0508 18.3733 10.1504 18.5702 10.3145 18.7254L16.7317 24.7948Z",
    fill: "#190134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackNav);
export default __webpack_public_path__ + "static/media/backNav.ec90f6c6933f5a854fc6c72b64e97c49.svg";
export { ForwardRef as ReactComponent };